import React, { useEffect } from "react";
import { useFieldArray, Controller } from "react-hook-form";
import {
  Form,
  Collapse,
  Input,
  Select,
  Space,
  Button,
  Switch,
  InputNumber,
} from "antd";

import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;

const FileSelectionConfigurationElement = (props) => {
  const { control, errors, setValue, watch } = props;
  const {
    fields: fileNameSelectionSegmentsFields,
    append: fileNameSelectionSegmentsAppend,
    remove: fileNameSelectionSegmentsRemove,
  } = useFieldArray({
    control,
    name: "job.fileSelection.fileNameSelectionSegments",
  });
  const {
    fields: extensionChangesFields,
    append: extensionChangesAppend,
    remove: extensionChangesRemove,
  } = useFieldArray({
    control,
    name: "job.extensionChanges",
  });

  const jobParametersArray = watch("job.jobParameters");

  useEffect(() => {
    switch (watch("job.fileSelection.dateModified.dateType")) {
      case "Days":
      case "Hours":
      case "Minutes":
        setValue("job.fileSelection.dateModified.dateValue", 1);
        break;
      default:
        setValue("job.fileSelection.dateModified.dateValue", null);
        break;
    }
  }, [watch("job.fileSelection.dateModified.dateType")]);

  const overrideDateFormatOnChange = (field) => {
    switch (watch("job.fileSelection.dateModified.dateType")) {
      case "Days":
      case "Hours":
      case "Minutes":
        return (
          <InputNumber {...field} defaultValue={1} style={{ width: "100%" }} />
        );
      case "Today":
      case null:
        return <Input disabled {...field} style={{ width: "100%" }} />;
      default:
        return <></>;
    }
  };
  const fileNameSelectionTypesOnChange = (field) => {
    switch (watch("job.fileSelection.fileNameSelectionType")) {
      case "BeginsWith":
        return <Input {...field} />;
      case "EndsWith":
        return <Input {...field} />;
      case "Contains":
        return <Input {...field} />;
      case "Regex":
        return <InputNumber {...field} style={{ width: "100%" }} />;
      case "All":
        return <Input {...field} disabled defaultValue={null} />;
      default:
        return <></>;
    }
  };
  const parameterType = (index, field) => {
    switch (
      watch(`job.fileSelection.fileNameSelectionSegments.${index}.segmentType`)
    ) {
      case "Fixed":
        return <Input placeholder="Enter Segment Value" {...field} />;
      case "Parameter":
        return (
          <>
            <Select {...field} placeholder="Segment Value">
              {jobParametersArray !== undefined
                ? jobParametersArray.map((elem) => (
                    <Option key={elem.name} value={elem.name}>
                      {elem.name}
                    </Option>
                  ))
                : undefined}
            </Select>
          </>
        );

      default:
        return (
          <Input
            style={{ width: "180%" }}
            placeholder="Enter Segment Value"
            {...field}
          />
        );
    }
  };

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["6"]} expandIconPosition="end">
          <Panel header="File Selection Configuration" key="6">
            <Form.Item {...formItemLayout} label="Process Subdirectory">
              <Controller
                control={control}
                name="job.fileSelection.getFilesRecursively"
                render={({ field: { value, onChange } }) => (
                  <Switch
                    checked={value}
                    onChange={(values) => {
                      onChange(values);
                    }}
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="File Extensions"
              help={errors.job?.fileSelection?.fileExtensions?.message}
              required
              validateStatus={
                errors.job?.fileSelection?.fileExtensions ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="job.fileSelection.fileExtensions"
                render={({ field: { onChange, value } }) => (
                  <Select
                    mode="tags"
                    placeholder="Enter Your File Extensions "
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Policy Check Extensions">
              <Controller
                control={control}
                name="job.fileSelection.policyCheckExtensions"
                render={({ field: { onChange, value } }) => (
                  <Select
                    mode="tags"
                    placeholder="Enter policy Check extensions"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="File Modified Date"
              help={errors?.job?.fileSelection?.dateModified?.dateType?.message}
              required
              validateStatus={
                errors?.job?.fileSelection?.dateModified?.dateType
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name="job.fileSelection.dateModified.dateType"
                render={({ field }) => (
                  <Select
                    {...field}
                    allowClear
                    showSearch
                    placeholder="Select Override Date Format"
                    optionFilterProp="children"
                  >
                    <Option value={null}>null</Option>
                    <Option value="Today">Today</Option>
                    <Option value="Days">Days</Option>
                    <Option value="Hours">Hours</Option>
                    <Option value="Minutes">Minutes </Option>
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="File Modified Date Value"
              help={
                errors?.job?.fileSelection?.dateModified?.dateValue?.message
              }
              required
              validateStatus={
                errors?.job?.fileSelection?.dateModified?.dateValue
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name="job.fileSelection.dateModified.dateValue"
                render={({ field }) => overrideDateFormatOnChange(field)}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="File Name Selection Type"
              help={errors.job?.fileSelection?.fileNameSelectionType?.message}
              required
              validateStatus={
                errors.job?.fileSelection?.fileNameSelectionType ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="job.fileSelection.fileNameSelectionType"
                render={({ field: { onChange, value } }) => (
                  <Select
                    showSearch
                    placeholder="Select File Name Selection Type"
                    onChange={onChange}
                    optionFilterProp="children"
                    value={value}
                  >
                    <Option value="All">All</Option>
                    <Option value="BeginsWith">BeginsWith</Option>
                    <Option value="EndsWith">EndsWith</Option>
                    <Option value="Contains">Contains</Option>
                    <Option value="Regex">Regex</Option>
                    <Option value="Parameter">Parameter</Option>
                  </Select>
                )}
              />
            </Form.Item>
            {watch("job.fileSelection.fileNameSelectionType") ===
            "Parameter" ? (
              <>
                <Form.Item
                  {...formItemLayout}
                  label="Segments Concat Character"
                  help={
                    errors.job?.fileSelection
                      ?.fileNameSelectionSegmentsConcatChar?.message
                  }
                  required
                  validateStatus={
                    errors.job?.fileSelection
                      ?.fileNameSelectionSegmentsConcatChar
                      ? "error"
                      : ""
                  }
                >
                  <Controller
                    control={control}
                    name="job.fileSelection.fileNameSelectionSegmentsConcatChar"
                    render={({ field }) => (
                      <Input
                        {...field}
                        defaultValue="_"
                        placeholder="Parameter Concat Character"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  {...formItemLayout}
                  label="File Name Selection Segments"
                  help={
                    errors?.job?.fileSelection?.fileNameSelectionSegments
                      ?.message
                  }
                  required
                  validateStatus={
                    errors?.job?.fileSelection?.fileNameSelectionSegments
                      ? "error"
                      : ""
                  }
                >
                  {fileNameSelectionSegmentsFields?.map((item, index) => {
                    return (
                      <>
                        <div>
                          <Space
                            key={item.id}
                            style={{
                              display: "Block",
                              marginBottom: 8,
                            }}
                            align="baseline"
                          >
                            <Form.Item
                              label="Segment Type"
                              help={
                                errors.job?.fileSelection
                                  ?.fileNameSelectionSegments?.[index]
                                  ?.segmentType?.message
                              }
                              required
                              validateStatus={
                                errors.job?.fileSelection
                                  ?.fileNameSelectionSegments?.[index]
                                  ?.segmentType
                                  ? "error"
                                  : ""
                              }
                            >
                              <Controller
                                control={control}
                                name={`job.fileSelection.fileNameSelectionSegments.${index}.segmentType`}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    showSearch
                                    placeholder="Select Segment Type"
                                    onChange={(e) => {
                                      onChange(e);
                                    }}
                                    value={value}
                                  >
                                    <Option value="Fixed">Fixed</Option>
                                    <Option value="Parameter">Parameter</Option>
                                  </Select>
                                )}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Segment Value"
                              help={
                                errors.job?.fileSelection
                                  ?.fileNameSelectionSegments?.[index]
                                  ?.segmentValue?.message
                              }
                              required
                              validateStatus={
                                errors.job?.fileSelection
                                  ?.fileNameSelectionSegments?.[index]
                                  ?.segmentValue
                                  ? "error"
                                  : ""
                              }
                            >
                              <Controller
                                control={control}
                                name={`job.fileSelection.fileNameSelectionSegments.${index}.segmentValue`}
                                render={({ field }) =>
                                  parameterType(index, field)
                                }
                              />
                            </Form.Item>
                            <Form.Item
                              label="Override Date Format"
                              help={
                                errors.job?.fileSelection
                                  ?.fileNameSelectionSegments?.[index]
                                  ?.overrideDateFormat?.message
                              }
                              required
                              validateStatus={
                                errors.job?.fileSelection
                                  ?.fileNameSelectionSegments?.[index]
                                  ?.overrideDateFormat
                                  ? "error"
                                  : ""
                              }
                            >
                              <Controller
                                control={control}
                                name={`job.fileSelection.fileNameSelectionSegments.${index}.overrideDateFormat`}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Override Date Format"
                                    onChange={(e) => {
                                      onChange(e);
                                    }}
                                    defaultValue={null}
                                    optionFilterProp="children"
                                    value={value}
                                  >
                                    <Option value={null}>null</Option>
                                    <Option value="yyyyMMdd">yyyyMMdd</Option>
                                    <Option value="yyyy-MM-dd">
                                      yyyy-MM-dd
                                    </Option>
                                    <Option value="dd-MM-yyyy">
                                      dd-MM-yyyy
                                    </Option>
                                    <Option value="MM-dd-yyyy">
                                      MM-dd-yyyy
                                    </Option>
                                    <Option value="yyyy/MM/dd">
                                      yyyy/MM/dd
                                    </Option>
                                    <Option value="dd/MM/yyyy">
                                      dd/MM/yyyy
                                    </Option>
                                    <Option value="MM/dd/yyyy">
                                      MM/dd/yyyy
                                    </Option>
                                  </Select>
                                )}
                              />
                            </Form.Item>

                            <MinusCircleOutlined
                              onClick={() =>
                                fileNameSelectionSegmentsRemove(index)
                              }
                            />
                          </Space>
                        </div>
                      </>
                    );
                  })}
                  <Button
                    block
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={() =>
                      fileNameSelectionSegmentsAppend({
                        segmentType: "",
                        segmentValue: null,
                        overrideDateFormat: null,
                      })
                    }
                  >
                    Add File Name Selection Segment
                  </Button>
                </Form.Item>
              </>
            ) : (
              <Form.Item
                {...formItemLayout}
                label="File Name Selection Value"
                help={
                  errors.job?.fileSelection?.fileNameSelectionValue?.message
                }
                required
                validateStatus={
                  errors.job?.fileSelection?.fileNameSelectionValue
                    ? "error"
                    : ""
                }
              >
                <Controller
                  control={control}
                  name="job.fileSelection.fileNameSelectionValue"
                  render={({ field }) => fileNameSelectionTypesOnChange(field)}
                />
              </Form.Item>
            )}
            <Form.Item
              {...formItemLayout}
              label="Selection Segment Match Type"
              help={
                errors.job?.fileSelection?.fileNameSelectionSegmentMatchType
                  ?.message
              }
              required
              validateStatus={
                errors.job?.fileSelection?.fileNameSelectionSegmentMatchType
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name="job.fileSelection.fileNameSelectionSegmentMatchType"
                render={({ field }) => (
                  <Select
                    {...field}
                    disabled={
                      watch("job.fileSelection.fileNameSelectionType") === "All"
                    }
                    showSearch
                    placeholder="Select file name selection segment match type"
                    defaultValue="Contains"
                  >
                    <Option value="Contains">Contains</Option>
                    <Option value="BeginsWith">BeginsWith</Option>
                    <Option value="EndsWith">EndsWith</Option>
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Extension Changes"
              help={errors.job?.extensionChanges?.message}
              required
              validateStatus={errors.job?.extensionChanges ? "error" : ""}
            >
              {extensionChangesFields?.map((item, index) => {
                return (
                  <>
                    <div>
                      <Space
                        key={item.id}
                        style={{
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          label="From"
                          help={
                            errors.job?.extensionChanges?.[index]?.from?.message
                          }
                          required
                          validateStatus={
                            errors.job?.extensionChanges?.[index]?.from
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.extensionChanges.${index}.from`}
                            render={({ field }) => (
                              <Input placeholder="Input From" {...field} />
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          label="To"
                          help={
                            errors.job?.extensionChanges?.[index]?.to?.message
                          }
                          required
                          validateStatus={
                            errors.job?.extensionChanges?.[index]?.to
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.extensionChanges.${index}.to`}
                            render={({ field }) => (
                              <Input placeholder="Input To" {...field} />
                            )}
                          />
                        </Form.Item>
                        <MinusCircleOutlined
                          onClick={() => extensionChangesRemove(index)}
                        />
                      </Space>
                    </div>
                  </>
                );
              })}
              <Button
                block
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() =>
                  extensionChangesAppend({
                    from: undefined,
                    to: undefined,
                  })
                }
              >
                Add Extension Changes
              </Button>
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};
export default FileSelectionConfigurationElement;
